import React, { Component } from 'react';
import { Tab } from 'semantic-ui-react'
import UserSitesTab from './user-sites/user-sites-tab'
import UserFundsTab from './user-funds/user-funds-tab'
import UserClientsTab from './user-clients/user-clients-tab'
import UserSubRolesTab from './user-sub-roles/user-sub-roles-tab'

class UserTabs extends Component {
  accessToPortfolio = [
    { menuItem: 'Funds', render: () => <Tab.Pane><UserFundsTab {...this.props} /></Tab.Pane> },
    { menuItem: 'Clients', render: () => <Tab.Pane><UserClientsTab {...this.props} /></Tab.Pane> },
    { menuItem: 'Sub-Roles', render: () => <Tab.Pane><UserSubRolesTab {...this.props} /></Tab.Pane> },
  ]

  accessToPortfolioNoFund = [
    { menuItem: 'Clients', render: () => <Tab.Pane><UserClientsTab {...this.props} /></Tab.Pane> },
    { menuItem: 'Sub-Roles', render: () => <Tab.Pane><UserSubRolesTab {...this.props} /></Tab.Pane> },
  ]

  accessToSites = [
    { menuItem: 'Sites', render: () => <Tab.Pane className="tab-wt"><UserSitesTab {...this.props} /> </Tab.Pane> },
    { menuItem: 'Funds', render: () => <Tab.Pane><UserFundsTab {...this.props} /></Tab.Pane> },
    { menuItem: 'Clients', render: () => <Tab.Pane><UserClientsTab {...this.props} /></Tab.Pane> },
    { menuItem: 'Sub-Roles', render: () => <Tab.Pane><UserSubRolesTab {...this.props} /></Tab.Pane> },
  ]

  accessToSitesNoFund = [
    { menuItem: 'Sites', render: () => <Tab.Pane className="tab-wt"><UserSitesTab {...this.props} /> </Tab.Pane> },
    { menuItem: 'Clients', render: () => <Tab.Pane><UserClientsTab {...this.props} /></Tab.Pane> },
    { menuItem: 'Sub-Roles', render: () => <Tab.Pane><UserSubRolesTab {...this.props} /></Tab.Pane> },
  ]
  render() {

    return <Tab panes={this.props.toggledTab ? (this.props.isFundLevel ? this.accessToPortfolio : this.accessToPortfolioNoFund ) :  (this.props.isFundLevel ? this.accessToSites : this.accessToSitesNoFund  )} />

  }
}
export default UserTabs;